<template>
    <!-- 补充资料 -->
    <common-modal :is-show-close="isShowClose" @close="close">
        <div class="comment-wrap">
            <h1 class="title">评价</h1>
            <div class="comment-level">
                <img :src="communalInfo.BucketDomain + server_icon" class="comment-icon" />
                <div>
                    <p class="comment-title">{{ server_name }}</p>
                    <span class="level" v-for="index in 5" :key="index" @click="rateStar(index)" :class="cur >= index ? 'on' : 'off'"></span>
                </div>
            </div>

            <div class="comment-text">
                <textarea rows="3" cols="20" placeholder="*请输入您的内容" v-model="feedback" maxlength="500"></textarea>
                <span>{{ feedback.length }}/500</span>
            </div>

            <div class="comment" @click="comment">发表评价</div>
        </div>
    </common-modal>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
import { getOrderComment } from '@/api/order.js';
import { mapState } from 'vuex';
export default {
    components: {
        commonModal
    },
    data() {
        return {
            isShowClose: true,
            feedback: '',
            cur: -1,
            server_name: '',
            order_uuid: '',
            server_icon: ''
        };
    },

    computed: {
        ...mapState(['communalInfo'])
    },

    methods: {
        getCommentInfo(order_uuid, server_icon, server_name) {
            this.order_uuid = order_uuid;
            this.server_icon = server_icon;
            this.server_name = server_name;
        },

        reset() {
            this.feedback = '';
            this.cur = -1;
            this.$emit('commentBack');
        },

        // 星级评价
        rateStar(index) {
            this.cur = index;
        },

        async comment() {
            if (this.cur < 0) {
                this.$message('请评价该订单');
                return;
            }

            if (!this.feedback) {
                this.$message('请输入内容');
                return;
            }
            if (this.feedback.length > 500) {
                this.$message('输入文字不得超过500个字符');
                return;
            }

            const parmas = { star: this.cur, order_uuid: this.order_uuid, comment: this.feedback };
            const { data, status } = await getOrderComment(parmas);
            if (status !== 200) return;
            this.reset();
            this.close();
            this.$message.success('评价成功');
        },

        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
textarea::-webkit-input-placeholder {
    @include textarea-placeholder;
}
textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    @include textarea-placeholder;
}
textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    @include textarea-placeholder;
}
textarea:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    @include textarea-placeholder;
}
.comment-wrap {
    padding: 30px;
    h1 {
        text-align: center;
        @include font-style;
        font-size: 20px;
        color: #000000;
    }
    .comment-level {
        display: flex;
        align-items: center;
        margin-left: 20px;
        margin-top: 30px;
        margin-bottom: 30px;
        .comment-icon {
            width: 60px;
            height: 60px;
            margin-right: 20px;
        }
        .comment-title {
            @include font-style;
            font-size: 18px;
            font-weight: 500;
            color: rgba(20, 20, 20, 1);
        }
        .level {
            @include cursor-style;
            margin-top: 8px;
            display: inline-block;
            width: 26px;
            height: 26px;
        }
        .on {
            background: url(../assets/img/star_light.png) no-repeat center;
            background-size: 100%;
        }
        .off {
            background: url(../assets/img/star_formal.png) no-repeat center;
            background-size: 100%;
        }
    }

    .comment-text {
        box-sizing: border-box;
        padding: 20px 15px 10px 20px;
        background: #f5f9fc;
        textarea {
            width: 100%;
            height: 180px;
            box-sizing: border-box;
            resize: none;
            background: #f5f9fc;
        }
        span {
            display: block;
            text-align: right;
            margin-top: 5px;
        }
    }

    //弹框按钮
    .comment {
        @include cursor-style;
        width: 380px;
        line-height: 50px;
        height: 50px;
        margin: 30px auto 0 auto;
        text-align: center;
        background: #ff8d1c;
        box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
        border-radius: 5px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }
}
</style>
